import Moment from "moment";

export default class Helper {
	static workCategories() {
		return ["Rutin", "Berkala_Pavemen", "Berkala_Bukan_Pavemen", "Kecemasan", "Agensi_Berkenaan"];
	}
	static titleCase(text) {
		return text.replace(/([a-z])([A-Z])/g, '$1 $2');
	}

	static snakeToTitleCase(text) {
		let result = text.split("_");

		result = result.map(t => t[0].toUpperCase().concat(t.substring(1, t.length))).join(" ");

		return result;
	}

	static generateCaseNumber(id) {
		let retVal = id.replace(/\D/g, '');
		return retVal.substring(retVal.length - 6);
	}

	static formatDate(date, noTime) {
		if (!date) {
			return "";
		} else {
			let format = noTime ? "D MMM YYYY" : "D MMM YYYY, h:mm A"
			return Moment(date).format(format);
		}
	}

	static formatMediaUrl(media) {
		if (media && media.url) {
			let url = media.url;

			return url.startsWith("http") ? url : `https://${url}`;
		} else {
			return false;
		}
	}

	static formatCoordinate(coord) {
		if (coord && coord.length == 2) {
			return `${parseFloat(coord[0]).toFixed(6)}, ${parseFloat(coord[1]).toFixed(6)}`;
		} else {
			return "";
		}
	}

	static getRoadInfo(road, breakLine) {
		if (!road) {
			return "";
		}

		let result = [];

		if (road.name) {
			result.push(road.name);
		}

		if (road.subdistrict) {
			result.push(road.subdistrict);
		}

		if (road.district) {
			result.push(road.district);
		}

		return result.join(breakLine ? "<br />" : ", ");
	}

	static socialMediaIcons(type) {
		const icons = {
			facebook: {
				i: ["fab", "facebook-square"],
				color: "facebook"
			},
			twitter: {
				i: ["fab", "twitter"],
				color: "twitter"
			},
			waze: {
				i: ["fab", "waze"],
				color: "waze"
			},
			instagram: {
				i: ["fab", "instagram"],
				color: "instagram"
			},
			mobile: {
				i: ["fas", "mobile-alt"],
				color: "dark"
			},
			ai: {
				i: ["fas", "video"],
				color: "dark"
			},
			textMessage: {
				i: ["far", "comments"],
				color: "info"
			},
			others: {
				i: ["fas", "comment-alt"],
				color: "muted"
			}
		}

		const result = icons[type];

		return result ? result : icons.others;
	}

	static colorPalettes = [
		"#ecdd7b",
		"#8f3bb3",
		"#bfdbf7",
		"#9d858d",
		"#776871",
		"#5c7457",
		"#eee1b3",
		"#dbad6a",
		"#cf995f",
		"#d0ce7c",
		"#b09e99",
		"#fee9e1",
		"#fad4c0",
		"#64b6ac",
		"#c0fdfb",
		"#5efc8d",
		"#8ef9f3",
		"#4c5760",
		"#01fdf6",
		"#03fcba"
	]
}